import { unities } from '@/common/constants/unities.constant'
import { FailedConsumptionData } from '@/common/types/client/failedConsumption.type'
import { formatCurrency, formatDecimal, formatUnit } from '@/common/utils/formatters'
import { useId } from 'react'
import { Tooltip } from 'react-tooltip'

type EstablishmentFailedConsumptionDetailsProps = {
  data: FailedConsumptionData
}

export const EstablishmentFailedConsumptionDetails = ({
  data: consumption,
}: EstablishmentFailedConsumptionDetailsProps) => {
  const uniqueId = useId()
  const failureFullMessage = consumption.failure_message || '--'
  const failureMessage = failureFullMessage.length > 32 ? `${failureFullMessage.slice(0, 32)}...` : failureFullMessage

  return (
    <div className="flex flex-col gap-3">
      <div className="flex gap-2 items-center">
        <p className="italic">Empresa cliente:</p>

        <p className="font-bold">
          {consumption?.client_branch?.general_information?.fantasy_name || consumption?.company_fantasy_name || consumption?.client_branch?.display_name || '--'}
        </p>
      </div>

      <div className="flex gap-2 items-center">
        <p className="italic">Mensagem de falha:</p>

        <p
          className="font-bold"
          data-tooltip-id={uniqueId}
          data-tooltip-place="top"
          data-tooltip-html={failureFullMessage.length > 20 ? failureFullMessage : undefined}
        >
          {failureMessage}
        </p>

        <Tooltip
          id={uniqueId}
          className="z-50 max-w-96 whitespace-pre-wrap break-words bg-[#1f1f1f] p-4 border border-gray-700 text-white-900 text-sm"
        />
      </div>

      <div className="flex flex-col justify-start">
        {consumption?.line_items.map((line_item) => (
          <p key={line_item.id}>
            {line_item.product.display_name} -{' '}
            {formatUnit(formatDecimal(line_item.quantity, 3), line_item.product.unit_for_quantity)} -{' '}
            {formatCurrency(Number(line_item.amount) / Number(line_item.quantity))}/
            {unities[line_item.product.unit_for_quantity]}
          </p>
        ))}
      </div>
    </div>
  )
}
